import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dashboard-financial',
  templateUrl: './financial.component.html',
  styleUrls: ['./financial.component.scss']
})
export class DashboardFinancialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
